import { z } from 'zod'

export const MonitoringChoiceSchema = z.enum(['yes', 'no', 'later'])
export const MonitoringOriginSchema = z.string().url().max(500).refine(value => {
  const url = new URL(value)
  return value === url.origin && (url.protocol === 'https:' || (url.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(url.hostname)))
}, 'Use an HTTPS origin, or HTTP localhost for development')
export const MonitoringActionSchema = z.discriminatedUnion('action', [
  z.object({ action: z.literal('prepare_setup'), project_id: z.string().min(1) }).strict(),
  z.object({ action: z.literal('preference'), project_id: z.string().min(1), choice: MonitoringChoiceSchema }).strict(),
  z.object({ action: z.literal('create_client'), project_id: z.string().min(1), name: z.string().trim().min(1).max(80), origins: z.array(MonitoringOriginSchema).min(1).max(10) }).strict(),
  z.object({ action: z.literal('rotate'), project_id: z.string().min(1), client_id: z.string().uuid() }).strict(),
  z.object({ action: z.literal('revoke'), project_id: z.string().min(1), client_id: z.string().uuid() }).strict(),
])
export const MonitoringClientSchema = z.object({ id: z.string().uuid(), name: z.string(), origins: z.array(z.string()), revoked: z.boolean(), last_received_at: z.string().nullable() })
export const MonitoringStatusSchema = z.object({
  preference_saved: z.boolean().default(false),
  choice: MonitoringChoiceSchema, org_id: z.string().nullable(), region: z.enum(['na1', 'eu1']).nullable(),
  clients: z.array(MonitoringClientSchema), session_count: z.number(),
})
export const MonitoringOwnershipSetupSchema = z.object({ target_url: z.string().url(), nonce: z.string() })
export const MonitoringKeyResponseSchema = z.object({ client_id: z.string().uuid(), key: z.string(), org_id: z.string(), region: z.enum(['na1', 'eu1']), endpoint: z.string().url(), ownership: MonitoringOwnershipSetupSchema.optional() })

export const MonitoringSetupErrorSchema = z.object({ data: z.object({ error: z.string() }) })
